<template>
  <div class="appointmentData">
    <div class="filter">
      <div class="filter_item">
        <div class="filter_item_label">创建时间</div>
        <el-date-picker
          class="filter_item_date"
          v-model="form.createTime"
          type="daterange"
          :editable="false"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
      </div>
      <div class="filter_item">
        <div class="filter_item_label">预约时间</div>
        <el-date-picker
          class="filter_item_date"
          v-model="form.reservationTime"
          type="daterange"
          :editable="false"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="filter_item">
        <div class="filter_item_label">执行时间</div>
        <el-date-picker
          class="filter_item_date"
          v-model="form.executeTime"
          type="daterange"
          :editable="false"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="filter_item">
        <div class="filter_item_label">预约单状态</div>
        <el-select class="filter_item_select" v-model="form.reservationStatusList" multiple collapse-tags clearable placeholder="请选择">
          <el-option
            v-for="item in reservationStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="filter_item">
        <div class="filter_item_label">预约渠道</div>
        <el-select class="filter_item_select" style="width: 250px;" v-model="form.sourceList" multiple collapse-tags clearable placeholder="请选择">
          <el-option
            v-for="item in sourceList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-if="nowDeptId == '0' || nowDeptId == '-1'" class="filter_item">
        <div class="filter_item_label">预约医馆</div>
        <el-select class="filter_item_select" v-model="form.deptId" clearable placeholder="请选择">
          <el-option
            v-for="item in deptList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="filter_action">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </div>

    <div class="table">
      <el-table
        :data="list"
        border
        style="width: 100%">
        <el-table-column prop="patientName" label="患者" min-width="100"></el-table-column>
        <el-table-column prop="patientPhone" label="手机号" min-width="120"></el-table-column>
        <el-table-column prop="reservedItemNames" label="预约项目" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="reservationDate" label="预约日期" min-width="100"></el-table-column>
        <el-table-column label="预约时间段" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.reservationStartTime }} - {{ scope.row.reservationEndTime }}
          </template>
        </el-table-column>
        <el-table-column prop="doctorName" label="治疗师" min-width="120"></el-table-column>
        <el-table-column prop="deptName" label="医馆" min-width="100"></el-table-column>
        <el-table-column label="预约状态" min-width="100">
          <template slot-scope="scope">
            {{ statusText(scope.row.reservationStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="预约渠道" min-width="140">
          <template slot-scope="scope">
            {{ sourceText(scope.row.source) }}
          </template>
        </el-table-column>
        <el-table-column prop="executeItemName" label="执行项目" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="executeStartTime" label="执行时间" min-width="160"></el-table-column>
        <el-table-column prop="cancelBy" label="取消人" min-width="120"></el-table-column>
        <el-table-column prop="cancelTime" label="取消时间" min-width="160"></el-table-column>
        <el-table-column prop="createBy" label="创建人" min-width="120"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        :current-page="pageNo"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="pageNoChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import req from '@/utils/request'
  export default {
    name: 'appointmentData',
    data() {
      return {
        nowDeptId: sessionStorage.getItem('deptId'),
        loading: false,
        reservationStatusList: [
          { label: '已预约', value: '1' },
          { label: '已签到', value: '6' },
          { label: '已完成', value: '3' },
          { label: '已取消', value: '2' },
          { label: '已结束', value: '5' }
        ],
        sourceList: [
          { label: '小程序-已购买预约', value: 'applet' },
          { label: '小程序-未购买预约', value: 'applet-quick' },
          { label: '平台-已购买预约', value: 'platform' },
          { label: '平台-未购买预约', value: 'trilateral' },
          { label: '三方平台', value: 'platform-intermediary' },
          { label: '医生小程序-已购买预约', value: 'weapp-doctor' },
          { label: '医生小程序-未购买预约', value: 'weapp-doctor-quick' }
        ],
        deptList: [],
        form: {
          createTime: [],
          reservationTime: [],
          executeTime: [],
          reservationStatusList: [],
          sourceList: [],
          deptId: ''
        },
        pageNo: 1,
        pageSize: 10,
        list: [],
        total: 0
      }
    },
    created () {
      const deptList = sessionStorage.getItem('options') && JSON.parse(sessionStorage.getItem('options'))
      this.deptList = deptList.filter(v => { return v.value !== 0 })

      if (sessionStorage.getItem('deptId') != '0') {
        this.form.deptId = Number(sessionStorage.getItem('deptId'))
      }

      const nowDay = new Date().Format('yyyy-MM-dd')
      this.form.createTime = [nowDay, nowDay]

      this.getList()
    },
    computed: {
      statusText () {
        return (value) => {
          const status = this.reservationStatusList.find(v => Number(v.value) === Number(value))
          return status ? status.label : ''
        }
      },
      sourceText () {
        return (value) => {
          const source = this.sourceList.find(v => v.value === value)
          return source ? source.label : ''
        }
      }
    },
    methods: {
      async getList () {
        const res = await req.post('/physio/operationsReport/page', {
          createStartTime: this.form.createTime && this.form.createTime.length > 0 ? this.form.createTime[0] : '',
          createEndTime: this.form.createTime && this.form.createTime.length > 0 ? this.form.createTime[1] : '',
          reservationStartTime: this.form.reservationTime && this.form.reservationTime.length > 0 ? this.form.reservationTime[0] : '',
          reservationEndTime: this.form.reservationTime && this.form.reservationTime.length > 0 ? this.form.reservationTime[1] : '',
          executeStartTime: this.form.executeTime && this.form.executeTime.length > 0 ? this.form.executeTime[0] : '',
          executeEndTime: this.form.executeTime && this.form.executeTime.length > 0 ? this.form.executeTime[1] : '',
          reservationStatusList: this.form.reservationStatusList,
          sourceList: this.form.sourceList,
          deptId: this.form.deptId,
          pageNum: this.pageNo,
          pageSize: this.pageSize
        })
        if (res.code === 200) {
          this.list = res.rows
          this.total = res.total
        }
      },
      pageNoChange (pageNo) {
        this.pageNo = pageNo
        this.getList()
      },
      search () {
        this.pageNo = 1
        this.getList()
      },
      reset () {
        const nowDay = new Date().Format('yyyy-MM-dd')
        this.form = {
          createTime: [nowDay, nowDay],
          reservationTime: [],
          executeTime: [],
          reservationStatusList: [],
          sourceList: [],
          deptId: sessionStorage.getItem('deptId') != '0' ? Number(sessionStorage.getItem('deptId')) : ''
        }
        this.pageNo = 1
        this.getList()
      },
    }
  }
</script>

<style lang="less" scoped>
  .appointmentData {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .filter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  }

  .filter_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .filter_item_label {
    flex-shrink: 0;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
  }

  .filter_item_date {
    margin: 0 0 0 12px;
    width: 240px;
  }

  .filter_item_date /deep/ .el-range__close-icon {
    line-height: 24px;
  }

  .filter_item_select {
    margin: 0 0 0 12px;
    width: 200px;
  }

  .filter_action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .table {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }
</style>
